<template>
  <ChartFrame :title="$t('Chart__DoctorsPerSector__name')">
    <ApexChart :options="options" :series="series" />
  </ChartFrame>
</template>

<script>
import ChartFrame from '@/components/ChartPartials/ChartFrame';
import data from '@/assets/json/DoctorsPerSector.json';

export default {
  name: 'DoctorsPerSector',
  components: {
    ChartFrame
  },
  data() {
    return {
      sheets: data,
      options: {
        chart: {
          type: 'line'
        },
        xaxis: {
          categories: data[0].axis
        },
        tooltip: {
          marker: {
            show: true,
            radius: 0
          }
        }
      }
    };
  },
  computed: {
    series() {
      return this.sheets[0].series
        .filter(item => item.name !== 'Other')
        .map(item => ({
          name: this.$t(item.name),
          data: item.data
        }));
    }
  }
};
</script>
